module.exports = "/assets/4a56831454092e3f5a9767ce8e75db7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IY.png
// module id = 2616
// module chunks = 0